import React, { useState } from 'react';
import AppMain from './components/AppMain';
import Header from './components/Header';
import Footer from './components/Footer';
import './App.css';

function App() {

    const [canScroll, setCanScroll] = useState(true);

    return (
      
        <div className="App">
            <Header className="App-header" />
            <AppMain className="App-main"
                canScroll={canScroll}
                setCanScroll={setCanScroll}
            />
    </div>
  );
}

export default App;
